import React from 'react'
import {Filter, TextInput} from 'react-admin'
import {withStyles} from '@material-ui/core/styles'
import {ReferencedPropertySelect} from '../../variation/components/shared-components'

const filterStyles = () => ({
    mainFilter: {
        padding: '5px'
    },
    filterNode: {
        marginLeft: '-50px'
    }
})

export const Filters = withStyles(filterStyles)(props => {
    const {classes, ...rest} = props
    return (
        <Filter {...rest} className={classes.mainFilter}>
            <TextInput
                alwaysOn
                label="Email"
                source="email"
                className="filter-text-style"
            />

            <ReferencedPropertySelect
                alwaysOn
                allowMultipleSelection
                allowAutoComplete
                label="Role"
                cReference="roles"
                source="roles.id"
                allowEmpty={false}
            />
        </Filter>
    )
})
